import React from "react";
import {
  MousePointerClick,
  MessageCircle,
  CalendarCheck,
  Truck,
} from "lucide-react";
import { howItWorks } from "../../mock";

const iconMap = { MousePointerClick, MessageCircle, CalendarCheck, Truck };

const ComoFunciona = () => {
  return (
    <section id="como-funciona" className="relative py-20 md:py-28">
      {/* subtle section background */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-[#120d1a] to-transparent opacity-60" />
      <div className="relative max-w-7xl mx-auto px-5">
        <div className="text-center">
          <span className="text-sm font-bold tracking-[0.2em] text-[#ec4899] uppercase">
            Como funciona
          </span>
          <h2 className="mt-4 font-display font-bold text-white text-3xl md:text-5xl leading-tight">
            Simples do começo ao fim
          </h2>
          <p className="mt-6 text-gray-400 text-lg max-w-2xl mx-auto leading-relaxed">
            Em poucos passos você garante a diversão da criançada sem dor de
            cabeça.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {howItWorks.map((s) => {
            const Icon = iconMap[s.icon];
            return (
              <div
                key={s.step}
                className="relative rounded-3xl border border-white/8 bg-[#0f0e17] p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-[#ec4899]/30"
              >
                <span className="font-display text-5xl font-black text-white/5 absolute top-5 right-6 select-none">
                  {s.step}
                </span>
                <div className="w-14 h-14 rounded-2xl bg-[#ec4899]/15 flex items-center justify-center mb-6">
                  <Icon size={26} className="text-[#ec4899]" />
                </div>
                <h3 className="font-display font-bold text-white text-lg mb-3">
                  {s.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ComoFunciona;
